/**
 * AUFTRAG-91 (20.10.2026): Artikelnummer (Shopify-Feld Barcode der Variante) folgt der Auswahl und lässt sich kopieren.
 * Markup: snippets/artnr.liquid ([data-artnr] mit [data-artnr-v], Knopf [data-artnr-copy], Rückmeldung [data-artnr-ok]).
 * Ereignisse: variant:changed (assets/variant-picker.js, detail.variant mit barcode) und freezer:change / freezer:ready
 * (assets/freezer-core.js, Barcode aus window.CryoFreezer.cur().v.bc, Feld aus snippets/freezer-product-json).
 * Ohne Barcode wird die Zeile verborgen. Mehrfach geladen (mehrere Aufrufe des Snippets) läuft es nur einmal.
 */
(function () {
  if (window.cryonosArtnr) return;
  function set(bc) {
    bc = bc == null ? '' : String(bc).trim();
    document.querySelectorAll('[data-artnr]').forEach(function (el) {
      var v = el.querySelector('[data-artnr-v]');
      if (v) v.textContent = bc;
      el.hidden = !bc;
      var ok = el.querySelector('[data-artnr-ok]');
      if (ok) ok.textContent = '';
    });
  }
  window.cryonosArtnr = { set: set };

  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && typeof v === 'object') set(v.barcode);
  });
  function fromFreezer() {
    try {
      var CF = window.CryoFreezer;
      if (CF && typeof CF.cur === 'function') set(CF.cur().v.bc);
    } catch (err) { /* Freezer-Seite noch nicht bereit */ }
  }
  document.addEventListener('freezer:change', fromFreezer);
  document.addEventListener('freezer:ready', fromFreezer);
  if (window.CryoFreezer && window.CryoFreezer.D) fromFreezer();

  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t).catch(function () { return legacyCopy(t); });
    return legacyCopy(t);
  }
  function legacyCopy(t) {
    return new Promise(function (ok, fail) {
      var ta = document.createElement('textarea');
      ta.value = t;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var done = false;
      try { done = document.execCommand('copy'); } catch (err) { done = false; }
      document.body.removeChild(ta);
      if (done) ok(); else fail();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-artnr-copy]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-artnr]') || btn.parentNode;
    var v = box.querySelector('[data-artnr-v]');
    var text = v ? v.textContent.trim() : '';
    if (!text) return;
    var ok = box.querySelector('[data-artnr-ok]');
    copyText(text).then(function () {
      if (!ok) return;
      ok.textContent = ok.getAttribute('data-text') || 'copied';
      clearTimeout(ok._t);
      ok._t = setTimeout(function () { ok.textContent = ''; }, 2000);
    }, function () {
      if (v && window.getSelection) {
        var r = document.createRange();
        r.selectNodeContents(v);
        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(r);
      }
    });
  });
})();
